import axiosInstance from "./axiosInstance";

export const getGrowthPlanCompanyDetailsApi = () =>
  axiosInstance.get("/api/v1/growth-plan/company-details");

export const postSubmitGrowthPlanAssessmentApi = (data) =>
  axiosInstance.post("/api/v1/growth-plan/assessment/submit", data);

export const postConfirmGrowthPlanAssessmentApi = (id, data) =>
  axiosInstance.post(`/api/v1/growth-plan/assessment/confirm/${id}`, data);

export const getGrowthPlanAssessmentListApi = (params) => {
  let path = "/api/v1/growth-plan/assessment-list";

  if (localStorage.getItem("role") === "1") {
    path = "/api/v1/admin/growth-plan/assessment-list";
  }

  if (localStorage.getItem("role") === "5") {
    path = "/api/v1/consultant/growth-plan/assessment-list";
  }

  return axiosInstance.get(path, {
    params: {
      ...params
    }
  });
};

export const postMarkAsVerifiedGrowthPlanAssessmentApi = (id) =>
  axiosInstance.post(`/api/v1/consultant/growth-plan/assessment/mark-as-verified/${id}`);

export const getGoalsListApi = () => axiosInstance.get("/api/v1/growth-plan/goals");

export const getDownloadGrowthPlanReportApi = (id) =>
  axiosInstance.get(`/api/v1/growth-plan/assessment/download/${id}`, {
    responseType: "blob",
    headers: {
      Accept: "application/pdf"
    }
  });
